import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { HomeSkeleton } from './home/HomeSkeleton';

export const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, loadingMessage } = useAuth();
  const context = useOutletContext();

  if (isLoading) {
    return <HomeSkeleton message={loadingMessage} />;
  }

  return isAuthenticated ? <Outlet context={context} /> : <Navigate to="/login" />;
}; 